import * as React from 'react'
import cx from 'classnames'
import styles from './Form.m.sass'

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {}

export default function Form({
  children,
  className,
  onSubmit,
  ...opts
}: FormProps) {
  return (
    <form
      className={cx(styles.form, className)}
      {...opts}
      onSubmit={createSubmitHandler(onSubmit)}
    >
      {children}
      {onSubmit && <input type="submit" hidden />}
    </form>
  )
}

/**
 * Creates a submit handler that will invoke the
 * specified function after preventing defaults.
 */
const createSubmitHandler =
  (onSubmit?: (e: React.FormEvent<HTMLFormElement>) => unknown) =>
  (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (onSubmit) onSubmit(e)
  }
